export default __webpack_public_path__ + "static/media/roomFour.40b2f62d.jpg";